import type { Language } from '../models';
import { getLanguageCodeAbbreviation } from './getLanguageCodeAbbreviation';

/**
 * Checks if current pathname has one of available languages present
 */
export const hasLanguageInUrl = (availableLanguages: Language[]): boolean => {
  /**
   * First part of pathname that can have one of available languages
   */
  const firstPartOfPathname = typeof window === 'undefined' ? undefined : window.location.pathname.split('/').at(1);

  return (
    availableLanguages.findIndex((item) => getLanguageCodeAbbreviation(item.code ?? '') === firstPartOfPathname) !== -1
  );
};
